import { render, staticRenderFns } from "./BookingLegalPopup.vue?vue&type=template&id=bff4ea76&scoped=true"
import script from "./BookingLegalPopup.vue?vue&type=script&lang=js"
export * from "./BookingLegalPopup.vue?vue&type=script&lang=js"
import style0 from "./BookingLegalPopup.vue?vue&type=style&index=0&id=bff4ea76&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff4ea76",
  null
  
)

export default component.exports